<template lang="pug">
  .order-stats
    template(v-for="item in stats")
      .order-stats__label
        span Со статусом «{{ $t('statuses.' + item) }}»:
      .order-stats__data
        span {{ getOrderStatsByStatus(item) || "-" }}
      .order-stats__action
        span
          router-link.link(
            :to=`{
              name: 'orders',
              params: { status: item }
            }`
          ) Показать
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      stats: ['measurement', 'contract', 'inproduction']
    };
  },

  computed: {
    ...mapState({
      ordersWait: state => state.orders.stats.measurement,
      ordersContract: state => state.orders.stats.contract,
      ordersProduction: state => state.orders.stats.inproduction
    })
  },

  methods: {
    getOrderStatsByStatus(status) {
      return this.$store.state.orders.stats[status];
    }
  }
};
</script>

<style lang="scss">
.order-stats {
  display: grid;
  grid-template-columns: auto 25px auto;
  row-gap: 0.5em;
  max-width: 380px;

  &__label,
  &__data {
    font-weight: bold;
  }
}
</style>
